// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseIcon_icon__2oIah"};